module.exports = __webpack_public_path__ + "static/media/speedpost.fc4da2bb.svg";